module.exports = __webpack_public_path__ + "static/img/1.ea518ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/1.jpg
// module id = 5W9C
// module chunks = 1